import { render, staticRenderFns } from "./UsersSearch.vue?vue&type=template&id=05a39ff7"
import script from "./UsersSearch.vue?vue&type=script&lang=js"
export * from "./UsersSearch.vue?vue&type=script&lang=js"
import style0 from "./UsersSearch.vue?vue&type=style&index=0&id=05a39ff7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports